import { render } from "./RegisterPage.vue?vue&type=template&id=b78dbd28&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=ts"
export * from "./RegisterPage.vue?vue&type=script&lang=ts"

import "./RegisterPage.vue?vue&type=style&index=0&id=b78dbd28&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b78dbd28"

export default script